<template>
    <div class="search">
        <div class="flex__between__center search-box">
            <div class="flex align-center search__item">
                <span class="fs_28 c_b3 jcicon jcicon-sousuo1">&nbsp;</span>
                <input type="text" class="fs_28 c_b3" @keyup.13=searchShow() v-focus="true" v-model="keyword" placeholder="请输入关键字搜索" ref="input1">
                <span class="jcicon jcicon-guanbi c_98" v-if="keyword" @click="keyword=''"></span>
            </div>
            <span class="fs_30 c_4d" v-if="keyword" @click="setKeyword">搜索</span>
            <span class="fs_30 c_4d" v-else @click="$router.go(-1)">取消</span>
        </div>
        <div class="box" v-if="renders.search_history.length">
            <div class="flex__between">
                <span class="fs_28 c_80">历史搜索</span>
                <span class="jcicon jcicon-shanchu1 fs_32 c_80" @click="del"></span>
            </div>
            <div class="flex wrap content bb_1">
                <div class="item" v-for="(item,index) in renders.search_history" :key="index" @click="setKeyword(item.content)">
                    <span class="fs_24 c_4d">{{item.content}}</span>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="flex__between">
                <span class="fs_28 c_80">热门搜索</span>
                <span class="iconfont icon-shanchu fs_32 c_80"></span>
            </div>
            <div class="flex wrap content">
                <div class="item" v-for="(item,index) in renders.search_hot" :key="index" @click="setKeyword(item.content)">
                    <span class="fs_24 c_4d">{{item.content}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'Search',
    directives: {
    // 注册一个局部的自定义指令 v-focus
        focus: {
            // 指令的定义
            inserted: function (el) {
                // 聚焦元素
                console.log(el.querySelector('input'));
                el.focus()
            }
        }
    },
    data(){
        return {
            renders:{
                search_hot:[],
                search_history:[]
            },
            keyword:'',
        }
    },
    methods:{
        searchShow(){
            this.$refs.input1.blur();
            this.setKeyword(this.keyword);
        },
        setKeyword (data) { 
            this.$store.commit('setKeyword',data);
            this.$router.push('/Mall/List/0/0');
        },
        // 删除历史记录
        del(){
            this.$dialog.confirm({
                message: '确认删除？'
            }).then(() => {
                this.axios.post('/wechat.php/Mall/deleteHistory',{
                    openid:localStorage.openid,
                    user_id:localStorage.user_id,
                    type: 1
                }).then(
                    res=>{
                        if(res.data.code==1){
                            this.renders.search_history=[];
                        }else{
                            this.$toast(res.data.message);
                        }
                    }
                )
            }).catch(()=>{})
        }
    },
    mounted(){
        this.axios.post('/wechat.php/Mall/getSearchData',{
            user_id:localStorage.user_id
        }).then(
            res=>{
                this.renders=res.data.data;
            }
        )
    }
}
</script>

<style scoped>
.search__item{
    width: 600px;
    height: 60px;
}
.box{
     padding: 30px 30px 0;
     background: #fff;
}
.content{
    padding-bottom: 30px;
}
.item{
    margin: 20px 20px 0 0;
    line-height: 60px;
    padding: 0 20px;
    background: #f5f5f5;
    border-radius: 4px;
}
</style>




// WEBPACK FOOTER //
// src/pages/mall/Search.vue